import React, { useContext, useState } from 'react'
import Dialog from '@mui/material/Dialog';

import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper';
import "./Dialog.scss";
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';

const AtomicDialog = (props) => {

    const {
        openOrderAlert, setOpenOrderAlert,
    } = useContext(GlobalStateDataContext)


    const { children, isLoading } = props



    const handleClose = () => {
        if (openOrderAlert) {
            setOpenOrderAlert(false);
        }
    };

    return (
        <Dialog
            open={openOrderAlert}
            // onClose={handleClose}  // This will close dialog if it clicked anywhere on screen
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-wrapper"
        >

            <div style={{
                width: 'calc(90vw - 0px)',
                // overflowY: 'none',
                // height: '80%',
                height: '100vh'
            }}>
                {children}

            </div>

        </Dialog>

    )
}

export default AtomicDialog